import { request } from '../http';
import type { OrgMember } from './organizations';

export type WorkspaceUserList = {
  workspaceMode: 'personal' | 'organization';
  workspaceName: string;
  organizationId?: string | null;
  items: OrgMember[];
};

export type WorkspaceUserPicker = {
  id: string;
  name?: string | null;
  email?: string | null;
  role?: string | null;
  is_enabled?: boolean;
};

export const workspaceUsersService = {
  list: () => request<WorkspaceUserList>('/workspace/users'),
  pickers: () => request<{ items: WorkspaceUserPicker[] }>('/workspace/users/pickers'),
  create: (body: {
    email: string;
    displayName?: string;
    workspaceRole: string;
    password?: string;
    enabled?: boolean;
    sourceIds?: string[];
  }) =>
    request<OrgMember>('/workspace/users', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};

/** Map workspace picker rows to the minimal shape used by share/transfer dialogs. */
export function workspacePickersAsUsers(items: WorkspaceUserPicker[]) {
  return items.map((item) => ({
    id: item.id,
    name: item.name ?? null,
    email: item.email ?? null,
    role: item.role ?? 'subscriber',
    is_enabled: item.is_enabled ?? true,
    channel: 'telegram',
    telegram_chat_id: null,
    subscription_count: 0,
  }));
}
